import { ButtonGroup, Dropdown } from 'react-bootstrap'
import { ButtonToolbar, OverlayTrigger } from "react-bootstrap";
import CustomToolTip from '../CommonComponents/CustomToolTip'
import './SimulateDetails.scss'
import { SimulateLogo, StatusSvg } from './svgs/Svgs'
import { get_formated_time, getFilterOption, getSatellitesCount, handleApplyFilters, getTooltipText, getStatusTextMessage, statusMap, getScenarioCurrentStep, getScenarioModeText } from './utils';
import { Fragment, useEffect, useMemo, useState, useRef } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import QuickDeployModal from './modals/quick_deploy/QuickDeployModal'
import DeployTypeModal from './modals/DeployTypeModal'
import SimulateService from '../../service/SimulateService'
import Loader from '../../Layouts/Loader/Loader'
import ConfirmationDialog from '../CommonComponents/confirmation_dialog/ConfirmationDialog'
import { AddNewEntityButton, FilterSvg } from '../CommonComponents/svgs/Svgs';
import { showToastMessage } from '../../utils/commonFunctions';
import dayjs from 'dayjs';
import LoaderAnimation from './modals/Loader/LoaderAnimation';
import CustomFilter from '../CommonComponents/custom_filter/CustomFilter';
import { AllFilterType, FilterListType } from '../CommonComponents/custom_filter/types';
import { ScenarioResponseType, SatelliteGroupType } from './types';
import { SCENARIO_DEPLOYMENT_TYPES, SCENARIO_STATUS } from './constants';

const SimulateDetails = () => {

    const navigate = useNavigate()
    const location = useLocation()
    const { mission_name, mission_id } = useParams()
    const [scenarios, set_scenarios] = useState<{
        all_scenarios: ScenarioResponseType[],
        filter_scenarios: ScenarioResponseType[],
        filter_applied: boolean
    }>({
        all_scenarios: [],
        filter_scenarios: [],
        filter_applied: false
    })

    const [open_deploy_type_modal, set_open_deploy_type_modal] = useState(false)
    const [open_quick_deploy_modal, set_open_quick_deploy_modal] = useState(false)
    const [open_confirmation_dialog, set_open_confirmation_dialog] = useState<boolean | any>(false)
    const [loading, set_loading] = useState<boolean | string>(true)
    const [selectedScenario, setSelectedScenario] = useState<any>(null);
    const [loadingState, setLoadingState] = useState<boolean | string>(false);
    const [allFilters, setAllFilters] = useState<AllFilterType>({})
    const [openConfirmationDialouge, setOpenConfirmationDialouge] = useState(false)
    const [showOverlay, setShowOverlay] = useState<string | null>(null);
    const scenarioActionRef = useRef<any>(null)

    const intervalRef = useRef<any>(null);

    const ACTIVE_STATES: string[] = [
        "DeploymentInProgress",
        "RedeployScenario",
        "UnDeployInProgress",
        "SimulationRunning",
    ]

    const filter_scenarios = useMemo(() => scenarios?.filter_scenarios || [], [scenarios?.filter_scenarios])
    const all_scenarios = useMemo(() => scenarios?.all_scenarios || [], [scenarios?.all_scenarios])
    const filterOption: FilterListType | null = useMemo(() => getFilterOption(filter_scenarios), [filter_scenarios])

    const navigateScenario = ({ type, mode, step, scenarioId }: { type?: string; mode?: 'create' | 'edit'; step?: string; scenarioId?: string }) => {
        const baseUrl = `${process.env.PUBLIC_URL}/mission/${mission_name}/${mission_id}/scenario`
        const params = new URLSearchParams()
        if (type) params.set('type', type)
        if (step) params.set('step', step)
        if (mode === 'edit' && scenarioId) params.set('scenarioId', scenarioId)
        navigate(`${baseUrl}?${params.toString()}`)
    }


    const update_scenario = (scenario: ScenarioResponseType) => {
        const scenarioId = scenario?.scenarioId
        const step = getScenarioCurrentStep(scenario)
        const type = scenario?.scenarioDeploymentType === SCENARIO_DEPLOYMENT_TYPES.TRUETWIN_COMMAND_CENTER ? 'open_scenario' : 'simulation'
        navigateScenario({ type, mode: 'edit', step: step, scenarioId: scenarioId })
    }
    const navigate_command_center = (scenario: ScenarioResponseType, status: string) => {

        let dashboard = 'summary'

        if (scenario?.scenarioDeploymentType === SCENARIO_DEPLOYMENT_TYPES.QUICK_DEPLOY) {
            dashboard = 'quick-deploy'
        } else if (scenario?.scenarioDeploymentType === SCENARIO_DEPLOYMENT_TYPES.GENERIC_SIMULATE) {
            if (scenario.status === SCENARIO_STATUS.SIMULATION_COMPLETED) {
                dashboard = 'summary'
            } else {
                dashboard = 'manual'
            }
        } else if (status === SCENARIO_STATUS.SIMULATION_RUNNING) {
            dashboard = 'simulation'
        } else if (scenario?.scenarioDeploymentType === SCENARIO_DEPLOYMENT_TYPES.TRUETWIN_COMMAND_CENTER) {
            dashboard = 'operate'
        }


        const scenarioId = scenario?.scenarioId

        if (!scenarioId) return

        // For Manual deployment, navigate without satellite and satelliteGroup params
        if (scenario?.scenarioDeploymentType === SCENARIO_DEPLOYMENT_TYPES.GENERIC_SIMULATE) {
            navigate(`${process.env.PUBLIC_URL}/${mission_name}/${mission_id}/${dashboard}/${scenarioId}/generic_simulator`)
            return
        }

        const satelliteId = scenario?.satelliteGroups[0]?.satellites[0]?.satelliteId
        const satelliteGroupId = scenario?.satelliteGroups[0]?.satelliteGroupId
        if (!scenarioId || !satelliteId) return
        navigate(`${process.env.PUBLIC_URL}/${mission_name}/${mission_id}/${dashboard}/${scenarioId}/satGroupId/${satelliteGroupId}/satellite/${satelliteId}/hud`)
    };

    const get_scenarios = async () => {
        try {
            const response = await SimulateService.getALLScenarios(mission_id)
            const payload = response?.data?.data ?? response?.data ?? []
            const all_scenarios = Array.isArray(payload) ? payload : []
            set_scenarios((prev => {
                return {
                    ...prev,
                    all_scenarios,
                    filter_scenarios: prev?.filter_applied
                        ? handleApplyFilters(all_scenarios, allFilters)
                        : all_scenarios,
                }
            }))
        } catch (error: any) {
            showToastMessage('error', error?.response?.data?.message || 'Something went wrong')
            if (intervalRef.current) {
                clearInterval(intervalRef.current)
            }
        } finally {
            set_loading(false)
        }
    }

    const delete_scenario = async (scenarioId: string) => {
        set_loading(scenarioId)
        try {
            const response = await SimulateService.deleteScenario(mission_id, scenarioId)
            if (response?.data) {
                const all_scenarios = scenarios?.all_scenarios.filter((scenario: ScenarioResponseType) => scenario.scenarioId !== scenarioId)
                set_scenarios(prev => {
                    const filter_scenarios = prev?.filter_scenarios.filter((scenario: ScenarioResponseType) => scenario.scenarioId !== scenarioId) || []
                    return {
                        ...prev,
                        all_scenarios: all_scenarios,
                        filter_scenarios: prev?.filter_applied ? filter_scenarios : all_scenarios
                    }
                })
                showToastMessage('success', response?.data || 'Scenario deleted successfully')
            }
        } catch (error: any) {
            const message = error?.response?.data || 'Something went wrong'
            showToastMessage('error', message)
        } finally {
            set_loading(false)
            scenarioActionRef.current = null
        }
    }

    const redeploy_scenario = async (scenarioId: string) => {
        setLoadingState("deploying")
        try {
            const data = {
                redeploymentStartTime: dayjs.utc(new Date()).unix()
            }
            const response = await SimulateService.reDeployRemotePayloadScenario(mission_id, scenarioId, data)
            get_scenarios()
            const scenario = response?.data?.data?.[0] || null
            setSelectedScenario(scenario)
            setLoadingState('download')
            showToastMessage('success', 'Scenario redeployed successfully')
        } catch (error: any) {
            showToastMessage('error', error?.response?.data?.message || 'Something went wrong')
            setLoadingState(false)
        }
    }



    const clone_scenario = async (scenarioId: string) => {
        set_loading(scenarioId)
        try {
            const response = await SimulateService.cloneScenario(mission_id, scenarioId)
            showToastMessage('success', response?.data?.message || 'Scenario cloned successfully')
            get_scenarios()
        } catch (error: any) {
            showToastMessage('error', error?.response?.data?.message || 'Something went wrong')
            set_loading(false)
        } finally {
            scenarioActionRef.current = null
        }
    }

    const select_deploy_type = (type: string) => {
        if (['simulation', 'open_scenario'].includes(type)) {
            navigateScenario({ type: type, mode: 'create', step: 'details' });
        } else if (type === 'quick_deploy') {
            set_open_deploy_type_modal(false)
            set_open_quick_deploy_modal(true)
        }
        return
    }

    const onCloseRedeployModal = () => {
        if (loadingState === "download") {
            setOpenConfirmationDialouge(true)
        } else {
            setLoadingState(false)
        }
    }

    const handleScenarioClick = (event: React.MouseEvent<HTMLElement>, scenario: ScenarioResponseType) => {
        const status = scenario.status
        const disabled = (
            status === SCENARIO_STATUS.DEPLOYMENT_IN_PROGRESS ||
            status === SCENARIO_STATUS.UNDEPLOY_IN_PROGRESS ||
            loading ||
            (scenario?.draftMode === 'Yes' && scenario?.scenarioDeploymentType === SCENARIO_DEPLOYMENT_TYPES.QUICK_DEPLOY)
        ) ? true : false
        if ((event.target instanceof HTMLElement && event.target.closest('.button__container')) || disabled) return

        // For Manual (GENERIC_SIMULATE) scenarios that are not running/completed,
        // do not navigate anywhere from the list (no retry from row click).
        if (
            scenario?.scenarioDeploymentType === SCENARIO_DEPLOYMENT_TYPES.GENERIC_SIMULATE &&
            status !== SCENARIO_STATUS.SIMULATION_RUNNING &&
            status !== SCENARIO_STATUS.SIMULATION_COMPLETED
        ) {
            return
        }

        else if (status !== SCENARIO_STATUS.SIMULATION_RUNNING && status !== SCENARIO_STATUS.SIMULATION_COMPLETED) {
            update_scenario(scenario)
        } else {
            navigate_command_center(scenario, status)
        }
    }

    const handleScenarioFilters = (scenarios: ScenarioResponseType[], filters: { [key: string]: any }) => {
        const updatedscenarios = handleApplyFilters(scenarios, filters);
        set_scenarios(prev => ({
            ...prev,
            filter_scenarios: updatedscenarios,
            filter_applied: scenarios.length !== updatedscenarios.length
        }))
    }

    const exportTelemetry = (scenario: ScenarioResponseType) => {
        const token = sessionStorage.getItem("authentication");
        const response = SimulateService.exportTelemetry(mission_id, scenario?.scenarioId, token)
        window.location.href = response;
    }

    useEffect(() => {
        if (!mission_id) return
        get_scenarios()
    }, [mission_id])

    // Show success toast after navigation
    useEffect(() => {
        if (!loading && location.state?.deploySuccessMessage) {
            showToastMessage('success', location.state.deploySuccessMessage);
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [loading, location.state?.deploySuccessMessage, navigate])

    useEffect(() => {
        if (!mission_id) return

        const allScenarioList = Array.isArray(scenarios?.all_scenarios) ? scenarios.all_scenarios : []
        if (!allScenarioList.length) return

        const hasActiveScenario = allScenarioList.some((s) => ACTIVE_STATES.includes(s.status))

        // No active scenario → stop interval
        if (!hasActiveScenario) {
            if (intervalRef.current) {
                clearInterval(intervalRef.current)
                intervalRef.current = null
            }
            return
        }

        // Active scenario → start interval only if not already running
        if (!intervalRef.current) {
            const Interval = setInterval(() => {
                if (!scenarioActionRef.current) {
                    get_scenarios()
                }
            }, 10000)
            intervalRef.current = Interval
        }
        // Cleanup ONLY when effect unmounts or mission changes
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current)
                intervalRef.current = null
            }
        }
    }, [scenarios?.all_scenarios, mission_id, allFilters])

    return (
        <Fragment>
            {loading && <Loader />}
            <div className='simulate__details__page'>
                <div className='simulate__page__header mt-4'>
                    <div className='d-flex gap-2 align-items-center'>
                        <SimulateLogo />
                        <span className='simulate__header__title'>Scenarios</span>
                    </div>
                    {all_scenarios?.length > 0 &&
                        <div className='simulate__filter__container'>
                            <CustomFilter
                                alignment='right'
                                search={{
                                    applyFilter: (filters: { [key: string]: any }) => {
                                        handleScenarioFilters(all_scenarios, filters)
                                    }
                                }}
                                advanceFilter={{
                                    filterIcon: <FilterSvg />,
                                    filterList: filterOption,
                                    applyFilter: (filters: { [key: string]: any }) => {
                                        handleScenarioFilters(all_scenarios, filters)
                                    }
                                }}
                                allFilters={allFilters}
                                setAllFilters={setAllFilters}
                                filterCase={'simulate'}
                                boundingScreen={'simulate__details__page'}
                            />
                        </div>
                    }
                    {all_scenarios?.length > 0 &&
                        <button className='simulate__header__deploy__button' onClick={() => set_open_deploy_type_modal(true)}>
                            <AddNewEntityButton /> New
                        </button>
                    }
                </div>
                {(!all_scenarios?.length || all_scenarios?.length === 0) &&
                    <div className='scenarioListEmptyState__container'>
                        <button className='scenarioListEmptyState' onClick={() => set_open_deploy_type_modal(true)}>
                            <AddNewEntityButton /> Create New Scenario
                        </button>
                    </div>
                }
                {all_scenarios?.length > 0 &&
                    <div className='simulate__page__body'>
                        <div className='simulate__page__body__header__container'>
                            <div className='simulate__body__table__header'>
                                <div className='w-20 d-flex justify-content-start'>
                                    <span className='w-25'>MODE</span>
                                    <span>SCENARIO</span>
                                </div>
                                <div className='w-15 d-flex justify-content-start'>SATELLITE(S)</div>
                                <div className='w-15 d-flex justify-content-start'>START TIME</div>
                                <div className='w-15 d-flex justify-content-start'>CREATION TIME</div>
                                <div className='w-10 d-flex justify-content-start'>DURATION</div>
                                <div className='w-20 d-flex justify-content-start'>STATUS</div>
                                <div className='flex-1' />
                            </div>
                        </div>
                        <div className='simulate__body__table__container'>
                            {filter_scenarios?.length > 0 && filter_scenarios.map((scenario: ScenarioResponseType, index) => {
                                const scenario_deployment_type = scenario?.scenarioDeploymentType
                                const rawStatus = scenario.draftMode === 'Yes' ? 'draft' : scenario?.status
                                const isManualScenario = scenario_deployment_type === SCENARIO_DEPLOYMENT_TYPES.GENERIC_SIMULATE
                                const isManualFailed =
                                    isManualScenario &&
                                    rawStatus !== SCENARIO_STATUS.DEPLOYMENT_IN_PROGRESS &&
                                    rawStatus !== SCENARIO_STATUS.SIMULATION_RUNNING &&
                                    rawStatus !== SCENARIO_STATUS.SIMULATION_COMPLETED
                                const status = isManualFailed ? 'Failed' : rawStatus
                                const isDeploymentInProgress = rawStatus === SCENARIO_STATUS.DEPLOYMENT_IN_PROGRESS
                                const isUndeploymentInProgress = rawStatus === SCENARIO_STATUS.UNDEPLOY_IN_PROGRESS
                                const isSimulationRunning = rawStatus === SCENARIO_STATUS.SIMULATION_RUNNING
                                const status_design = status === 'draft' ? 'draft' : statusMap[status] ?? (isManualFailed ? 'failed' : 'ready_to_deploy');
                                const disabled = (isDeploymentInProgress || isUndeploymentInProgress || loading) ? true : false
                                const statusAction = (
                                    <div className='simulate__body__table__row__button'>
                                        {isDeploymentInProgress ? (
                                            <div className='spin__loader' />
                                        ) : isUndeploymentInProgress ? (
                                            <div className='spin__loader__red' />
                                        ) : isSimulationRunning ? (
                                            <div className='spin__loader__green' />
                                        ) : (
                                            <StatusSvg status={status} />
                                        )}
                                    </div>
                                )

                                return (
                                    <div className={`simulate__body__table__row ${disabled && 'disabled'} ${status_design}`} key={index}
                                        onClick={(event) => {
                                            handleScenarioClick(event, scenario)
                                        }}
                                    >
                                        <div className='w-20 pe-3 d-flex flex-row align-item-center'>
                                            <div className='w-25 d-flex align-items-center justify-content-start'>
                                                <span className='deployment_type_text deployment_type_container'>
                                                    {getScenarioModeText(scenario_deployment_type)}
                                                </span>
                                            </div>
                                            <span className={`text-truncate scenario__row__text flex-1 fs-14 fw-light`}>
                                                <CustomToolTip title={scenario.scenarioName} placement='top-start'>
                                                    {scenario.scenarioName}
                                                </CustomToolTip>
                                            </span>
                                        </div>
                                        <ButtonToolbar key={`group`} className={`w-15 d-flex justify-content-start scenario__row__text fw-semibold`}
                                            onMouseEnter={() => { setShowOverlay(scenario?.uniqueId) }}
                                            onMouseLeave={() => { setShowOverlay(null) }}
                                        >
                                            <OverlayTrigger placement="top-start" show={showOverlay === scenario?.uniqueId}
                                                overlay={
                                                    scenario?.satelliteGroups?.length > 0 ? (  // Ensure we only show the overlay if there are groups
                                                        <div className='sateGroupsTitlesModal'>
                                                            {scenario?.satelliteGroups?.map(group => (
                                                                <div title={group?.satelliteGroupName} className='sateGroupsTitlesModalRow' key={group?.satelliteGroupName}>
                                                                    <span className='sateGroupsTitlesModalRowText'>{group?.satelliteGroupName}</span>
                                                                    <span className='sateGroupsTitlesModalRowTextCount'>({group?.satelliteCount})</span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ) : <></> // Return an empty fragment if no groups exist
                                                }>
                                                <span className='w-95 text-truncate'>
                                                    {scenario?.satelliteGroups?.length > 1
                                                        ? `${getSatellitesCount(scenario?.satelliteGroups as SatelliteGroupType[])} Satellites`
                                                        : scenario?.satelliteGroups?.length === 1
                                                            ? (scenario?.satelliteGroups[0].satelliteCount === 1
                                                                ? scenario?.satelliteGroups[0]?.satelliteGroupName
                                                                : `${scenario?.satelliteGroups[0].satellites.length} Satellites`)
                                                            : '-'}
                                                </span>
                                            </OverlayTrigger>
                                        </ButtonToolbar>

                                        <div className={`w-15 d-flex scenario__row__text`}>
                                            {scenario?.simulationStartTime ? get_formated_time(scenario?.simulationStartTime).split('Z')[0] + ' UTC' : '-'}
                                        </div>
                                        <div className={`w-15 d-flex scenario__row__text`}>
                                            {scenario?.createdAt ? scenario?.createdAt.split('Z')[0].split('.')[0] + ' UTC' : '-'}
                                        </div>
                                        <div className={`w-10 d-flex scenario__row__text`}>
                                            {scenario.simulationDuration} Min
                                        </div>
                                        <div className='w-20 d-flex align-items-center justify-content-between'>
                                            <div className='status__badge'>
                                                <div className='status__indicator' />
                                                {isManualFailed ? 'Failed' : getStatusTextMessage(status)}
                                            </div>
                                            {isManualFailed ? (
                                                <div className='simulate__body__table__row__button' />
                                            ) : (
                                                <CustomToolTip title={getTooltipText(status)} placement='top'>
                                                    {statusAction}
                                                </CustomToolTip>
                                            )}
                                        </div>
                                        <div className='flex-1 d-flex justify-content-end button__container'>
                                            <ButtonGroup size="sm" className="flex-nowrap mb-0">
                                                <div className="btn-list more-button">
                                                    <Dropdown drop="end">
                                                        <Dropdown.Toggle
                                                            size="sm"
                                                            variant="transparent"
                                                            disabled={isDeploymentInProgress || isUndeploymentInProgress || loading! === scenario?.uniqueId}
                                                            className='pr-0'
                                                        >
                                                            <i className="fe fe-more-vertical fs-20"></i>
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu className='button__dropdown__container'>
                                                            {scenario?.scenarioDeploymentType !== SCENARIO_DEPLOYMENT_TYPES.QUICK_DEPLOY && scenario?.scenarioDeploymentType !== SCENARIO_DEPLOYMENT_TYPES.GENERIC_SIMULATE &&
                                                                <Dropdown.Item eventKey="0"
                                                                    className='button__dropdown__item'
                                                                    disabled={loading! === scenario?.uniqueId || status === SCENARIO_STATUS.SIMULATION_RUNNING || status === SCENARIO_STATUS.SIMULATION_COMPLETED || isDeploymentInProgress || isUndeploymentInProgress}
                                                                    onClick={() => {
                                                                        update_scenario(scenario)
                                                                    }}
                                                                >
                                                                    Edit
                                                                </Dropdown.Item>
                                                            }
                                                            {scenario?.scenarioDeploymentType !== SCENARIO_DEPLOYMENT_TYPES.QUICK_DEPLOY && scenario?.scenarioDeploymentType !== SCENARIO_DEPLOYMENT_TYPES.GENERIC_SIMULATE &&
                                                                <Dropdown.Item eventKey="1"
                                                                    className='button__dropdown__item'
                                                                    disabled={isDeploymentInProgress || isUndeploymentInProgress}
                                                                    onClick={() => {
                                                                        scenarioActionRef.current = scenario?.scenarioId
                                                                        clone_scenario(scenario?.scenarioId)
                                                                    }}
                                                                >
                                                                    Clone
                                                                </Dropdown.Item>
                                                            }
                                                            {(scenario?.scenarioDeploymentType === SCENARIO_DEPLOYMENT_TYPES.QUICK_DEPLOY && status === SCENARIO_STATUS.SIMULATION_COMPLETED) &&
                                                                <Dropdown.Item eventKey="2"
                                                                    className='button__dropdown__item'
                                                                    disabled={!scenario?.enableRedeploy}
                                                                    onClick={() => {
                                                                        set_open_confirmation_dialog({
                                                                            name: scenario?.scenarioName,
                                                                            scenarioId: scenario?.scenarioId,
                                                                            scenarioType: scenario_deployment_type,
                                                                            confirmationText: "Re-Deploy",
                                                                            modalType: "discard",
                                                                            description: `Re-Deploying this scenario will overwrite the old scenario data.`,
                                                                            title: "Re-Deploy Scenario?",

                                                                        })
                                                                    }}
                                                                >
                                                                    Re-Deploy
                                                                </Dropdown.Item>
                                                            }
                                                            {status === SCENARIO_STATUS.SIMULATION_COMPLETED && scenario?.scenarioDeploymentType !== SCENARIO_DEPLOYMENT_TYPES.GENERIC_SIMULATE && 
                                                                <Dropdown.Item eventKey="3"
                                                                    className='button__dropdown__item'
                                                                    onClick={() => {
                                                                        exportTelemetry(scenario)
                                                                    }}
                                                                >
                                                                    Export Telemetry
                                                                </Dropdown.Item>
                                                            }
                                                            <Dropdown.Item eventKey="4"
                                                                className='button__dropdown__item'
                                                                disabled={loading! === scenario?.uniqueId || status === SCENARIO_STATUS.SIMULATION_RUNNING || isDeploymentInProgress || isUndeploymentInProgress}
                                                                onClick={() => {
                                                                    set_open_confirmation_dialog({
                                                                        name: scenario?.scenarioName,
                                                                        scenarioId: scenario?.scenarioId,
                                                                        scenarioType: scenario_deployment_type,
                                                                        confirmationText: "Delete",
                                                                        modalType: "delete",
                                                                        description: `Deleting ${scenario?.scenarioName} will permanently remove it from the database, and it cannot be restored once deleted.`,
                                                                        title: `Delete ${scenario_deployment_type === "QUICK_DEPLOY" ? 'Quick deploy' : 'Scenario'}?`
                                                                    })
                                                                }}
                                                            >
                                                                Delete
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </ButtonGroup>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>

                    </div>
                }
            </div>
            <DeployTypeModal
                open={open_deploy_type_modal}
                close={() => set_open_deploy_type_modal(false)}
                select_deploy_type={(type: string) => {
                    select_deploy_type(type)
                }}
            />
            <QuickDeployModal
                open={open_quick_deploy_modal}
                close={() => {
                    get_scenarios()
                    set_open_quick_deploy_modal(false)
                }}
            />

            <ConfirmationDialog
                open={open_confirmation_dialog ? true : false}
                type={open_confirmation_dialog?.modalType as "delete" | "discard" | "update" | "cancel"}
                title={open_confirmation_dialog?.title}
                description={open_confirmation_dialog?.description}
                onConfirm={() => {
                    if (open_confirmation_dialog?.modalType === "delete") {
                        scenarioActionRef.current = open_confirmation_dialog?.scenarioId
                        delete_scenario(open_confirmation_dialog?.scenarioId as string);
                    } else if (open_confirmation_dialog?.modalType === "discard") {
                        redeploy_scenario(open_confirmation_dialog?.scenarioId as string);
                    }
                    set_open_confirmation_dialog(false)
                }}
                onCancel={() => { set_open_confirmation_dialog(false) }}
                confirm_button_text={`${open_confirmation_dialog?.confirmationText}`}
            />

            {loadingState &&
                <div className='loader__animation__modal__container'>
                    <div className='loader__animation__modal'>
                        <LoaderAnimation
                            loadingState={loadingState}
                            setLoadingState={setLoadingState}
                            scenario={selectedScenario}
                            errorMessage={'Error Occured'}
                            onClose={onCloseRedeployModal}
                        />

                    </div>
                </div>
            }
            <ConfirmationDialog
                open={openConfirmationDialouge}
                type={"delete"}
                title={"Discard Deployment"}
                description={`Discarding will take you back to the list of deployments`}
                onConfirm={() => {
                    setLoadingState(false)
                    setOpenConfirmationDialouge(false)
                }}
                onCancel={() => {
                    setOpenConfirmationDialouge(false)
                }}
                confirm_button_text="Discard"
            />

        </Fragment>

    )

}

export default SimulateDetails
